import React, { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import SortablePageSectionItemHeader from './SortablePageSectionItemHeader';
import SortablePageSectionItemBlockHolder from './SortablePageSectionItemBlockHolder';
import Grabber from '../svg/Grabber2';
import AddPlus from '../svg/AddPlus';
import i18n from '../../i18n';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

class SortablePageSections extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: this.props.sections || [],
            loaded: false,
        };
        this.onDragEnd = this.onDragEnd.bind(this);
        this.deleteContentSection = this.deleteContentSection.bind(this);
    }

    componentDidUpdate(prevProps) {
        if ((!this.props.changing && this.props.changing !== prevProps.changing) || 
            (this.props.sections?.length !== this.state.items?.length && 
             this.props.sections?.length !== prevProps.sections?.length)) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                loaded: true,
                items: this.props.sections || [],
            });
        }
        if ((this.props.changing && this.props.changing !== prevProps.changing)) {
            if (this.state.loaded) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ loaded: false });
            }
        }
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        // Validate source and destination
        if (!result.source || result.source.index === undefined || 
            result.destination.index === undefined) {
            console.error('Invalid drag operation: missing source or destination index');
            return;
        }

        const sourceIndex = result.source.index;
        const destIndex = result.destination.index;

        // No change if dropped in same position
        if (result.source.droppableId === result.destination.droppableId && 
            sourceIndex === destIndex) {
            return;
        }

        if (result.type === 'droppableItem') {
            // eslint-disable-next-line react/no-access-state-in-setstate
            const items = reorder(this.state.items, sourceIndex, destIndex);

            let canReorder = true;

            if (this.props.canReorderSubItems) {
                canReorder = this.props.canReorderSubItems(items);
            }

            if (canReorder) {
                this.setState({
                    items: items
                });
                if (this.props.onItemsDisplayOrderChange) {
                    this.props.onItemsDisplayOrderChange(items);
                }
            }
        } else if (result.type === 'droppableSubItem') {
            const itemSubItemMap = this.state.items.reduce((acc, item) => {
                acc[item.id] = item.contents;
                return acc;
            }, {});

            const sourceParentId = result.source.droppableId;
            const destParentId = result.destination.droppableId;

            const sourceSubItems = itemSubItemMap[sourceParentId];
            const destSubItems = itemSubItemMap[destParentId];

            let newItems = [...this.state.items];
            /** In this case contents are reOrdered inside same Parent */
            if (sourceParentId === destParentId) {
                const reorderedSubItems = reorder(
                    sourceSubItems,
                    sourceIndex,
                    destIndex,
                );
                newItems = newItems.map((item) => {
                    if (item.id === sourceParentId) {
                        return {
                            ...item,
                            contents: reorderedSubItems,
                        };
                    }
                    return item;
                });

                let canReorder = true;

                if (this.props.canReorderSubItems) {
                    canReorder = this.props.canReorderSubItems(newItems);
                }

                if (canReorder) {
                    newItems = newItems.map(i => ({ ...i, contents: i.contents.filter(c => c !== undefined) }));

                    this.setState({
                        items: newItems
                    });
                    if (this.props.onItemsDisplayOrderChange) {
                        this.props.onItemsDisplayOrderChange(newItems);
                    }
                }
            } else {
                const newSourceSubItems = sourceSubItems?.length > 0 ? [...sourceSubItems] : [];
                const [draggedItem] = newSourceSubItems.splice(sourceIndex, 1);

                const newDestSubItems = destSubItems?.length > 0 ? [...destSubItems] : [];
                if (destSubItems?.length > 0) {
                    newDestSubItems.splice(destIndex, 0, draggedItem);
                } else {
                    newDestSubItems.push(draggedItem);
                }
                newItems = newItems.map((item) => {
                    let i = item;
                    if (item.id === sourceParentId) {
                        i.priorContents = i.contents;
                        i.contents = newSourceSubItems.filter(c => c !== undefined);
                    }
                    if (item.id === destParentId) {
                        i.priorContents = i.contents;
                        i.contents = newDestSubItems.filter(c => c !== undefined);
                    }
                    return i;
                });

                let canReorder = true;

                if (this.props.canReorderSubItems) {
                     canReorder = this.props.canReorderSubItems(newItems);
                }

                if (canReorder) {
                    this.setState({
                        items: newItems
                    });
                    if (this.props.onItemsDisplayOrderChange) {
                        this.props.onItemsDisplayOrderChange(newItems);
                    }
                } else {
                    newItems.forEach((item) => {
                        item.contents = item.priorContents;
                    });
                }
            }
        }
    }

    deleteContentSection(id) {
        this.props.deleteContentSection(id);
    }

    // Normally you would want to split things out into separate components.
    // But in this example everything is just done in one place for simplicity
    render() {
        const items = this.state.items || [];
        
        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable" type="droppableItem">
                    {(provided) => {
                        return (
                            <div
                                data-qa="section-card-holder"
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {items.map((item, index) => {
                                    if (!item || !item.id) {
                                        console.warn('Invalid item found in sections:', item);
                                        return null;
                                    }
                                    return (
                                        <Draggable
                                            key={item.id}
                                            draggableId={item.id}
                                            index={index}
                                            isDragDisabled={this.props.changing}
                                        >
                                            {/* eslint-disable */}
                                            {(provided) => {
                                                return (

                                                    <div className="section-card">
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                        >
                                                            <SortablePageSectionItemHeader
                                                                item={item}
                                                                index={index}
                                                                onSingleItemChange={this.props.onSingleItemChange}
                                                                deleteContentSection={this.deleteContentSection}
                                                                changing={true}
                                                                sectionCount={this.state.items.length}
                                                            />

                                                            <span
                                                                className="dragger"
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <Grabber />
                                                            </span>
                                                            <SortablePageSectionItemBlockHolder
                                                                contents={item.contents || [{}]}
                                                                type={item.id}
                                                                editContentBlock={this.props.editContentBlock}
                                                                deleteContentBlock={this.props.deleteContentBlock}
                                                                addDivider={this.props.addDivider}
                                                                forms={this.props.forms}
                                                                pages={this.props.pages}
                                                            />
                                                            <button type="button" className="add-content-block" onClick={() => { this.props.addContentBlock(item.id) }}>
                                                                <AddPlus />
                                                                {' '}
                                                                { i18n.t('content.add-content') }
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            }}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                            </div>
                        );
                    }}
                </Droppable>
            </DragDropContext>
        );
    }
}

export default SortablePageSections;
